import { materialInfo } from '@/mocks/products';

export default function MaterialStory() {
  return (
    <section className="bg-secondary-100 w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            Materials Your Pet Can Actually Trust
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Every material we use is chosen for one reason: it's safe enough to go in your pet's mouth, and tough enough to survive what comes next.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {materialInfo.map((mat, i) => (
            <div key={i} className="bg-background-50 rounded-2xl p-5 md:p-6 card-hover-lift">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${mat.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-800 mb-2.5">{mat.name}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{mat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}